import { useState } from "react";
import "./App.css";
import { ThemeProvider } from "@mui/material";
import { lightTheme, darkTheme } from "./theme";
import Router from "./routes";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { NotificationServiceProvider } from "./components/notification";
import { AuthProvider } from "./hooks/useAuth";

const queryClient = new QueryClient();

function App() {
  // Detect user's preferred color scheme
  //  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: light)');
  const [isDarkMode, setIsDarkMode] = useState(false);

  return (
    <AuthProvider>
      <QueryClientProvider client={queryClient}>
        <NotificationServiceProvider>
          <ThemeProvider theme={isDarkMode ? darkTheme : lightTheme}>
            <Router />
          </ThemeProvider>
        </NotificationServiceProvider>
      </QueryClientProvider>
    </AuthProvider>
  );
}

export default App;
